<template lang="html">
  <div v-if="!isCustomer">
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
      <d-button size="sm" theme="success" @click.prevent="finishProject()" v-if="project.finished_at === null">
        <i class="fas fa-check"></i><span class="d-none d-lg-inline"> Finalizar Obra</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _OPEN_CONFIRMATION_ } from '_modules/project/components/ProjectModel';

export default {
  name: 'project-buttons',
  props: {
    project: {
      type: Object,
      default: null,
    },
  },
  components: {},
  data() {
    return {
      isCustomer: false,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'checkIsCustomer',
    ]),
    checkUser() {
      this.checkIsCustomer().then(response => {
        this.isCustomer = response;
      });
    },
    finishProject() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_OPEN_CONFIRMATION_, { project: this.project, type: 'finish' });
    },
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_OPEN_CONFIRMATION_, { project: this.project, type: 'delete' });
    },
  },
  mounted() {
    this.checkUser();
  },
};
</script>
